/* eslint-disable simple-import-sort/imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react'
import { FaRegCalendarAlt } from 'react-icons/fa'
import { VisitorChart } from '../components/Chart'
import {
  getAggregate,
  getCountries,
  getDevices,
  getTimeSeries,
  getClicks,
  getTopLinks,
  getSources,
} from '../services/plausible/getData'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css' // Import Flatpickr CSS
import moment from 'moment'
import TopLinks from '../components/AnalyticBlock/TopLinks'
import TopCointries from '../components/AnalyticBlock/TopCountries'
import TopSources from '../components/AnalyticBlock/TopSources'
import TopDevices from '../components/AnalyticBlock/TopDevices'
import Lifetime from '../components/AnalyticBlock/Lifetime'
import { useTranslation } from 'react-i18next'
type AnalyticsBlockProps = {
  username: string | undefined
}

export const AnalyticsBlock = ({ username = '' }: AnalyticsBlockProps) => {
  const { t } = useTranslation()
  const [stats, setStats] = useState<any>(null) // Aggregate total data
  const [timeSeries, setTimeSeries] = useState(null) // Data by period
  const [clicks, setClicks] = useState(0)
  const datepickerRef = useRef(null)
  const [countries, setCountries] = useState<any>(null)
  const [os, setOs] = useState<any>(null)
  const [browsers, setBrowsers] = useState<any>(null)
  const [sources, setSources] = useState<any>(null)
  const [devices, setDevices] = useState(null)
  const [selectedDates, setSelectedDates] = useState<any>(null)
  const [topLinks, setTopLinks] = useState(null)

  const getClicksData = async () => {
    const clicks = await getClicks(username)
    setClicks(clicks.events.value)
  }

  const getAggregateData = async () => {
    const data = await getAggregate(username)
    setStats(data)
  }

  const getTimeSeriesData = async () => {
    const timeSeries = await getTimeSeries(username, selectedDates)
    setTimeSeries(timeSeries)
  }

  const getCountriesData = async () => {
    const countries = await getCountries(username)
    setCountries(countries)
  }

  const getSourcesData = async () => {
    const sources = await getSources(username)
    setSources(sources)
  }

  const getTopLinksData = async () => {
    const topLinks = await getTopLinks(username)
    setTopLinks(topLinks)
  }

  const getDevicesData = async () => {
    const devices = await getDevices(username, 'visit:device')
    setDevices(devices)
  }

  const getOsData = async () => {
    const os = await getDevices(username, 'visit:os')
    setOs(os)
  }

  const getBrowserData = async () => {
    const browsers = await getDevices(username, 'visit:browser')
    setBrowsers(browsers)
  }

  useEffect(() => {
    getAggregateData()
    getTimeSeriesData()
    getClicksData()
    getTopLinksData()
    getCountriesData()
    getSourcesData()
    getDevicesData()
    getOsData()
    getBrowserData()
  }, [selectedDates])

  useEffect(() => {
    if (datepickerRef.current) {
      flatpickr(datepickerRef.current, {
        dateFormat: 'M J, Y',
        mode: 'range',
        closeOnSelect: true,
        defaultDate: [
          moment().subtract(28, 'days').format('MMM Do, YYYY'),
          moment().format('MMM Do, YYYY'),
        ],
        onClose: (selectedDates) => {
          if (selectedDates.length === 0) return
          setSelectedDates(selectedDates)
        },
        onReady: (selectedDates) => {
          setSelectedDates(selectedDates)
        },
      })
    }
  }, [])

  console.log('stats', stats)
  
  return (
    <div className="mx-auto mb-6 mt-6 flex w-[640px] flex-col p-6 sm:top-0">
      <h3 className="mb-6 text-center text-2xl font-bold">{t('Analytics')}</h3>
      <Lifetime stats={stats} clicks={clicks} />
      <div className="relative mb-6">
        <FaRegCalendarAlt className="absolute left-4 top-2 h-6 w-6 cursor-pointer " />
        <input
          className="shadow-input h-10 w-full rounded-lg p-4 pl-12"
          ref={datepickerRef}
          type="text"
        />
      </div>

      {timeSeries && <VisitorChart data={timeSeries} />}
      {topLinks && <TopLinks data={topLinks} />}
      {countries && <TopCointries data={countries} />}
      {sources && <TopSources data={sources} />}
      {devices && (
        <TopDevices data={{ devices: devices, os: os, browsers: browsers }} />
      )}
    </div>
  )
}